import axios from 'axios'
import {
  baseURL,
  contentType,
  debounce,
  requestTimeout,
  successCode,
  tokenName,
} from '@/config'
import store from '@/store'
import qs from 'qs'
import router from '@/router'
import { isArray } from '@/utils/validate'
import { message } from 'ant-design-vue'

let loadingInstance

/**
 * @author chuzhixin 1204505056@qq.com
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
const handleCode = (code, msg) => {
  console.log({code})
  console.log({msg})
  switch (code) {
    case 'A0230':
    case 401:
      message.error(msg || '登录失效')
      console.log('store.dispatch开始了===')
      store.dispatch('user/resetAll').catch(() => {
        console.log('catch函数')
        router.push('/login')
      })
      break
    case 403:
      router.push({ path: '/401' }).catch(() => {})
      break
    default:
      message.error(msg || `后端接口${code}异常`)
      break
  }
}

/**
 * @author chuzhixin 1204505056@qq.com
 * @description axios初始化
 */
const instance = axios.create({
  // baseURL,
  timeout: requestTimeout,
  headers: {
    'Content-Type': contentType,
  },
})
instance.defaults.baseURL = process.env.VUE_APP_BASE_API_URL
/*axios.defaults.timeout = requestTimeout
axios.defaults.withCredentials = true
//axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.post['Content-Type'] = contentType*/



/**
 * @description axios请求拦截器
 */
instance.interceptors.request.use(
  (config) => {
    if (store.getters['user/accessToken'])
      //config.headers[tokenName] = store.getters['user/accessToken']
      config.headers['Authorization'] = store.getters['user/accessToken']

    if (
      config.data &&
      config.headers['Content-Type'] ===
        'application/x-www-form-urlencoded;charset=UTF-8'
    )
      config.data = qs.stringify(config.data)
    if (debounce.some((item) => config.url.includes(item))) {
      //这里写加载动画
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * @description axios响应拦截器
 */
instance.interceptors.response.use(
  (response) => {
    if (loadingInstance) loadingInstance.close()

    const { data, config } = response

    // 下载文件统一处理
    if(response.headers["content-disposition"]){
      // 用返回二进制数据创建一个Blob实例
      let blob = new Blob([data])
      // 通过URL.createObjectURL生成文件路径
      let url = window.URL.createObjectURL(blob)
      // 创建a标签
      let ele = document.createElement("a")
      ele.style.display = 'none'
      // 设置href属性为文件路径，download属性可以设置文件名称
      ele.href = url
      let headers = response.headers
      let tempName =headers["content-disposition"].split(";")[1].split("filename=")[1];
      ele.download = decodeURIComponent(tempName)
      // 将a标签添加到页面并模拟点击
      document.querySelectorAll("body")[0].appendChild(ele)
      ele.click()
      // 移除a标签
      ele.remove()
      return

    }
    // 操作正常Code数组
    /*const codeVerificationArray = isArray(successCode)
      ? [...successCode]
      : [...[successCode]]*/
    // 是否操作正常
    //if (codeVerificationArray.includes(code)) {

    const { code, message } = data
    if (code === "00000") {
      return data
    } else {
      handleCode(code, message)
      return Promise.reject(
        'vue-admin-beautiful请求异常拦截:' +
          JSON.stringify({ url: config.url, code, message }) || 'Error'
      )
    }
  },
  (error) => {
    if (loadingInstance) loadingInstance.close()
    //const { response, message } = error
    let response = error.response
    let _message = error.message
    if (error.response && error.response.data) {
      const { status, data } = response
      handleCode(status, data.msg || _message)
      return Promise.reject(error)
    } else {
      //let { message } = error
      //let _message = error.message
      if (_message === 'Network Error') {
        _message = '后端接口连接异常'
      }
      if (_message.includes('timeout')) {
        _message = '后端接口请求超时'
      }
      if (_message.includes('Request failed with status code')) {
        const code = _message.substr(_message.length - 3)
        _message = '后端接口' + code + '异常'
      }
      message.error(_message || `后端接口未知异常`)
      return Promise.reject(error)
    }
  }
)

export default instance
